import { createThunk, ThunkDispatch, favoritesLeftNavItemId } from '../../../../shared';
import {
    getPackageState,
    lpcDemoteSelfCompletedAction,
    getActiveLeftNavItemId,
} from '../../../../appstate';
import { HubState, packageStateKey } from '../../../state';
import { getNextUnifiedGroupIdInList } from '../../../selectors/groups/currentUnifiedGroupSelector';

export const lpcDemoteSelfCompleted = (groupId: string, hubPersonaId: string) =>
    createThunk('lpcDemoteSelfCompleted', (dispatch: ThunkDispatch, getState: () => {}): void => {
        const packageState = getPackageState<HubState>(getState(), packageStateKey);
        if (packageState) {
            const activeLeftNavId = getActiveLeftNavItemId(packageState.appState);
            let nextListItemId;
            if (activeLeftNavId === favoritesLeftNavItemId) {
                nextListItemId = hubPersonaId;
            } else {
                nextListItemId = getNextUnifiedGroupIdInList(
                    packageState.appState,
                    packageState.packageState
                );
            }

            dispatch(lpcDemoteSelfCompletedAction({ groupId, nextListItemId, hubPersonaId }));
        }
    });
